import { Col, Row } from "antd";
import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Preloader from "../../../../../../../CommonComponents/Preloader/Preloader";
import { startDate, todayDate } from "../../../../../../../utils/commonUtil";
import { receiveAllocationTableData, updateIndividualSpawn } from "../../../actions";
import { scheduleAllocationDerivedStates } from '../../../Selectors/ScheduleAllocationSelectors';
import { allocationCalculator } from "../../../utils";
import GrantAllocationForm from "../../GrantAllocation/GrantAllocation";
import GrantAllocationTable from "../../GrantAllocationTable/GrantAllocationTable";
import EditRecommendAllocation from "./EditRecommendAllocation";
import { ErrorModal } from "./Errors";
import moment from "moment"
import {isEqual} from "lodash";


export class EditSpawn extends Component {
    
    constructor(props)
    {
        super(props);
        this.allocationRef =  createRef()
        const lowBalCheck = this.lowBalCheck(
          this.getAvailableBalance(),
          props.fromEdit
        );
        this.state = {
          scheduleType: "recurring",
          amount: props.selectedAmount,
          allocationPref: this.props.allocationType
          ,
          showPercentageExceedFlag:false,
          startDate: props.selectedDate || "",
          allocations: props.selectedAllocations,
          allSharesAllPools:  false,
          allShares:  false,
          weightedAllocEdit: false,
          entireBalPopup: false,
          isFormValid:true,
          showDecimalError:false
        };

    }

    mapAllocationPref = (allocationPref)=>{
      return allocationPref === "perDollarAmount" ? "byDollars" : allocationPref;
    }

    componentDidMount()
    {
      this.props.drillRef(this);
      let grantIdParam = `&grantId=${this.props.grantTemplateId}`;
        this.props.receiveAllocationTableData({
            method: "GET",
            url: `/donor-portal/api/investment/${
              this.props.accountId
            }/findInvestmentPoolsForGrantSubmitByAccountIdStartDateAndEndDate?startDateStr=${startDate(
              7
            )}&endDateStr=${todayDate()}${grantIdParam}`,
            page: "recommendGrant"
          });  
    }

   isEqualCheck = ()=>{
      const propsValues = {
        amount:this.props.selectedAmount,
        selectedDate:this.props.selectedDate,
        allocationType:this.props.allocationType,
        allocations:this.props.selectedAllocations,
      }

      const stateValues = {
        amount:this.state.amount,
        selectedDate:this.state.startDate,
        allocationType:this.state.allocationPref,
        allocations:this.state.allocations,
      }
      return !isEqual(propsValues,stateValues)

    }

    decimalError = ()=>{
      if(this.state.allocationPref === "byPercentage")
      {
      let isInteger = this.state.allocations.every((element,index)=>{

       return   Number.isInteger(parseFloat(element.grantPercentage))
       
      })
      return !isInteger
     
    }
    return false

    }

    submitHandler = async (redirect)=>{
      const {form} = this.allocationRef.current ;     
        try
      {
        const result =  await form.validateFields();
        if(this.isEqualCheck())
        {
            if(this.decimalError())
            {
              this.setState({
                showDecimalError:true
              })
              return null
            }

      if (
        !allocationCalculator(
          this.state.allocations,
          this.mapAllocationPref(this.state.allocationPref),
          this.state.amount
        )
      ) {
        this.setState({
          showPercentageExceedFlag: true
        });
        return null
      }
      if(!this.state.isFormValid) throw new Error("form not valid")
      const json = {
        "scheduleId":this.props.scheduleIdForSpawns,
        "spawnId":this.props.spawnId,
          "issueDate":moment(this.state.startDate).format("YYYY-MM-DD"),
          "amount":this.state.amount,
          "allocationType": this.state.allocationPref === "perDollarAmount"?"byDollars":this.state.allocationPref,
          "grantAllocation":this.state.allocations.map((elm)=>{
            return {
              "position": {
                "pool": {
                  "poolId": elm.id
                }
              },
              "percentageAllocated":this.state.allocationPref === "byPercentage"?Math.trunc(elm.grantPercentage):null,
              "amountAllocated":this.state.allocationPref === "perDollarAmount"?elm.grantAmount:null,
              "weightedPercenatgePerPool":this.state.allocationPref === "weightedAllocations"?elm.grantAmount:null,
              "allocatedUnits":null
            }
          })
      }
      this.props.updateIndividualSpawn({
        userId: this.props.accountId,
        updateData:json,
        onSuccess:redirect
      });

    }
    else
    {
      redirect()
    }
      }
      catch (err)
      {
        return null
      }
   
    }

    getAvailableBalance = ()=>{
      let   availableBalance =
          Number(this.props.availableBalance) + Number(this.props.selectedAmount);
      return availableBalance.toFixed(2);
    }
    

    lowBalCheck = (availableBalance, editMode) => {
        const minAmount = 500;
        if (editMode) {
          return false;
        }
        return Number(availableBalance) < Number(minAmount);
      };


      handleFormChange = (values,v)=>{
        const {amount,startDate} = values;
        if(amount)
        {
          if(!amount.validating && !amount.errors)
          {
            this.setState({
              amount:amount.value
            })
          }
        }
        else if(startDate)
        {
          this.setState({
            startDate:startDate.value
          })
        }
      }

   

    handleAllocationChange = allocationData => {
      this.setState({
        allocations:allocationData.allocations,
        allocationPref:allocationData.grantAmountOrPercentFieldChange?this.state.allocationPref === "weightedAllocations"?"perDollarAmount":"weightedAllocations":this.state.allocationPref,
        isFormValid:allocationData.isFormValid,
        weightedAllocEdit:allocationData.grantAmountOrPercentFieldChange??false
      })
    };
    handleAllocationPrefChange=(preference)=>{
      this.setState({
        allocationPref: preference,
        weightedAllocEdit:false
      });
    }

    percentExceedCancel = () => {
      this.setState({
        showPercentageExceedFlag: false
      });
    };

    
    decimalErrorCancel = () => {
      this.setState({
        showDecimalError: false
      });
    };
  

render() {
    const {
        allocationData,
        allocationLoading,
        fromEdit,
      } = this.props;
      const {
          allocationPref,scheduleType,weightedAllocEdit,startDate,amount,showPercentageExceedFlag,allocations,showDecimalError
      } = this.state;

      const availableBalance = this.getAvailableBalance();
      const lowBalCheck = this.lowBalCheck(availableBalance, fromEdit);
      return (
        <>
      <EditRecommendAllocation realAvailableBalance={this.props.availableBalance} availableBalance={availableBalance} selectedDate={startDate} grantAmount={amount} handleFormChange={this.handleFormChange}   wrappedComponentRef={this.allocationRef}
/>
    <GrantAllocationForm
    isEnabled={!!amount}
    allocationPref={allocationPref=="byPercentage"?"perDollarAmount":allocationPref}
    onChange={this.handleAllocationPrefChange}
    disabled={lowBalCheck}
    scheduleType={this.state.scheduleType}
  >
    {allocationLoading ? (
      <Preloader />
    ) : (
      <>
        <Row>
          <Col lg={24} md={24} xs={24}>
            <GrantAllocationTable
              allocationData={allocationData}
              availableBalance={availableBalance}
              amount={amount}
              allocationPreference={this.mapAllocationPref(allocationPref)}
              scheduleType={scheduleType}
              onChange={this.handleAllocationChange}
              allocations={allocations}
              allSharesAllPoolsOnly={false}
              allSharesAllPools={false}
              allShares={false}
              showAllSharesColumn={true}
              page={"Recommend a Grant"}
              weightedAllocEdit={weightedAllocEdit}
              fromEdit={fromEdit}
              ref={this.myRef}
              entireBalPopup={this.state.entireBalPopup}
            />
          </Col>
        </Row>
      </>
    )}
  </GrantAllocationForm>
  <ErrorModal showModal={showPercentageExceedFlag} cancelModal={this.percentExceedCancel} />
  <ErrorModal showModal={showDecimalError} cancelModal={this.decimalErrorCancel} decimalError />
  </>
      )
}
    
}

export const mapDispatchToProps = dispatch => ({
  receiveAllocationTableData: payload => dispatch(receiveAllocationTableData(payload)),
  updateIndividualSpawn: (payload) => dispatch(updateIndividualSpawn(payload))
});

export const mapStateToProps = state => ({
  ...scheduleAllocationDerivedStates(state.toJS())
});


export default  connect(mapStateToProps, mapDispatchToProps,null,{forwardRef:true})(EditSpawn);